/* eslint-disable react/no-invalid-html-attribute */

import React from 'react';
import Head from 'next/head';
import BaseLayout from '@/components/common/BaseLayout';
import TAGS from '../../public/headJson.json';
import AboutUs from '../components/AboutUs';
import RouteName from '../utils/route.util';

const AboutUsPage = () => {
  return (
    <>
      <Head>
        {/* Primary Meta Tags */}
        <title>{TAGS.aboutUs.title}</title>
        <meta name="title" content={TAGS.aboutUs.title} />
        <meta name="description" content={TAGS.aboutUs.desc} />
        <link rel="canonical" href={`${RouteName.aboutUs}/`} />

        {/* Facebook */}
        <meta property="og:url" content={RouteName.aboutUs} />
        <meta property="og:title" content={TAGS.aboutUs.title} />
        <meta property="og:description" content={TAGS.aboutUs.desc} />

        {/* Twitter */}
        <meta property="twitter:url" content={RouteName.aboutUs} />
        <meta property="twitter:title" content={TAGS.aboutUs.title} />
        <meta property="twitter:description" content={TAGS.aboutUs.desc} />
      </Head>
      <BaseLayout category={undefined}>
        <AboutUs />
      </BaseLayout>
    </>
  );
};

export default AboutUsPage;
